"use strict";

// References
var alt = require("../alt");
var MarketActions = require("../actions/MarketActions");
var AuthStore = require("./AuthenticationStore");
var networking = require("../utils/Networking.js");
var Networking = new networking();
var _ = require("underscore");

class MarketStore {
    // Data

    constructor() {
        this.bindActions(MarketActions);
        this.marketItems = [];
        this.filteredMarketItems = [];
        this.filterData = {
            "query": "",
            "account": "",
            "owner": "",
            "types": [],
            "departments": [],
            "locations": [],
            "statuses": ["48df1cf3-481b-4daf-a68d-3b5abde83470"]
        };
    }

    // Functions
    onGetAllItems() {

        var success = function(result) {
            var newState = {};
            newState["marketItems"] = _.indexBy(result, "id");
            newState["filteredMarketItems"] = _.indexBy(result, "id");
            this.setState(newState);
        }.bind(this);
        var failure = function(error) {
            console.error("filterEquipment() fail", error)
            var newState = {};
            var message = "Ekki tókst að sækja vörur í sölu";
            if (error.responseJSON.detail && error.responseJSON.detail !== "") {
                message = error.responseJSON.detail;
            }
            newState.notification = {
                "type": "error",
                "message": message,
                "color": "rgb(242, 222, 222)",
                "isActive": true,
                "dismissAfter": 8000
            }
            this.setState(newState);
        }.bind(this);

        Networking.GET("for_sale/", success, failure);
    }

    onClearItems() {
        this.setState({marketItems: {}});
    }

    onFilterEquipment(filter) {
        var marketItems = this.marketItems;

        var filteredMarketItems = _.filter(marketItems, function(item){
            var isInDepartment = _.contains(filter.departments, item.department) || _.isEmpty(filter.departments);
            var isInType = _.contains(filter.types, item.type) || _.isEmpty(filter.types);
            var isInLocation = _.contains(filter.locations, item.location) || _.isEmpty(filter.locations);

            var shouldReturn = isInDepartment &&  isInType && isInLocation;

            return shouldReturn;
        });

        var newState = {}
        newState["filteredMarketItems"] = _.indexBy(filteredMarketItems, "id");
        this.setState(newState);

    }

    onRefreshFilter(){
        var account = AuthStore.getState().account;
        var owner = AuthStore.getState().id;
        if(account && owner){
            var filterData = this.filterData;
            filterData.account = account;
            filterData.owner = owner;
            this.onFilterEquipment(filterData);
        }
    }

    onClearFilter(){
        var account = AuthStore.getState().account;
        var owner = AuthStore.getState().id;
        if(account && owner){
            var filterData = {};
            filterData.account = account;
            filterData.owner = owner;
            filterData.query = "";
            filterData.types = [];
            filterData.departments = [];
            filterData.locations = [];
            this.filterData = filterData;
            this.onGetAllItems();
        }
    }

}


var marketScore = alt.createStore(MarketStore, "MarketStore");

window.marketScore = marketScore;

module.exports = marketScore;



// WEBPACK FOOTER //
// ./app/scripts/stores/MarketStore.js